const SPONSORED_ARTICLES_CINEMA_IDENTIFIER = 'sponsoredArticlesCinema';

export default {
    loadDetailViewCinema: (variationId) => {
        const url = `/auction-presentation/cinemas/detailview?variationId=${variationId}`;

        return window.o_util.ajax
            .get(url)
            .then((response) => {
                if (response.status !== 200) {
                    throw response;
                }
                return response.responseText;
            })
            .then((responseHtml) => {
                const tempDom = document.createElement('div');
                tempDom.innerHTML = responseHtml;

                const response = {};
                const sponsoredArticlesCinemaHtml = tempDom.getElementsByClassName(SPONSORED_ARTICLES_CINEMA_IDENTIFIER);
                if (sponsoredArticlesCinemaHtml.length > 0) {
                    response[SPONSORED_ARTICLES_CINEMA_IDENTIFIER] = sponsoredArticlesCinemaHtml[0].innerHTML;
                }
                return response;
            });
    }
}